<template>
    <div class="monthly-assessment-table">
        <m-search-list ref="searchList" :searchId="searchId" :list="configJson.searchList" @onSearchChange="searchChange">
            <div slot="table-module-btn" class="btn-box">
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <el-button type="el-icon-setting" size="mini" icon="el-icon-download" @click="exportList"></el-button>
                </el-tooltip>
            </div>
        </m-search-list>
        <div class="monthly-table">
            <el-table border :data="tableData" :height="height" v-loading="loading">
                <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                <el-table-column v-for="(item, index) in columnsList" :key="index+item.label" :prop="item.prop" :label="item.label"
                    align="center" :min-width="item.width?item.width : ''">
                    <template v-if="item.list">
                        <el-table-column v-for="(item2, index2) in item.list" :key="index2+item2.label" :prop="item2.prop" :label="item2.label"
                            align="center" :min-width="item2.width?item2.width : ''"></el-table-column>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination class="text-right" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="searchInfo.pageNo" :page-sizes="[10, 20, 30, 50, 100]" :page-size="searchInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"></el-pagination>
    </div>
</template>
<script>
import mSearchList from '../../../../components/searchList';
import { getChart, getWorkTable, findSiteInfo } from '../../../../api/achievements/monthlyAssessment';
import { dictWithUrl } from '@/components/lots/api';
import configJson from './config.json';
import formatTime from '@/utils/common.js';
import config from '@/config/user.env';
import { mapState } from 'vuex';
export default {
    components: { mSearchList },
    props: {
        height: String
    },
    data() {
        return {
            configJson,
            searchId: 'searchListConfig',
            searchInfo: {
                pageNo: 1,
                pageSize: 10
            },
            totalCount: 0,
            tableData: [],
            exportUrl: '/api-srm-web/performance/portal/exportAssessmentDetailList',
            dictData: {}, // 数字字典
            loading: false,
            columnsList: [
                {
                    prop: 'assessmentMonth',
                    label: '考核月份',
                    width: '90'
                },
                {
                    prop: 'companyName',
                    label: '分公司',
                    width: '90'
                },
                {
                    prop: 'siteName',
                    label: '平台',
                    width: '90'
                },
                {
                    prop: 'businessCategory',
                    label: '业务大类',
                    width: '90'
                },
                {
                    prop: 'supplierName',
                    label: '供应商',
                    width: '140'
                }
            ],
            columnsLast: [{
                prop: 'overallRating',
                label: 'KPI考核总评分',
                width: '110'
            },
            {
                prop: 'rank',
                label: '排名',
                width: '90'
            }]
        };
    },
    computed: {
        ...mapState({ supplier: state => state.supplier })
    },
    created() {
        dictWithUrl('SRM_PERFOR_BUSINESS_CATEGORY').then(res => {
            this.dictData = res.data;
            this.searchInfo.supplierCode = this.supplier === undefined ? '' : this.supplier.supplierCode;// 获取供应商编码
            this.configJson.searchList.searchTxt.forEach(async el => {
                el.rule = [];
                if (el.value === 'siteName') {
                    el.advanceUrl = `/portal/findSiteInfo?supplierCode=${this.supplier.supplierCode}`;
                    const res = await findSiteInfo({ pageNo: 1, pageSize: 1, supplierCode: this.supplier.supplierCode });
                    if (res.data.list.length) {
                        el.data = {
                            siteName: res.data.list[0].escoCompanyNameCn,
                            siteCode: res.data.list[0].escoCompanyNo
                        };
                    }
                }
                if (el.value === 'assessmentYear') {
                    el.data = '2020';
                }
                this.loading = true;
                setTimeout(() => {
                    this.$refs.searchList.onSearchChange();
                    el.rule = [{ 'required': true, 'message': ' ' }];
                }, '1000');
            });
        });
    },
    mounted() {
        // 数字字典转换
    },
    methods: {
        async loadData() {
            this.loading = true;
            this.columnsList = this.$options.data().columnsList;// 重置columnsList的数据
            const res = await getWorkTable({ ...this.searchInfo });
            this.loading = false;
            if (res && res.code === '0') {
                if (res.data.list[0] && res.data.list[0].quotaTypeDtoList) {
                    res.data.list[0].quotaTypeDtoList.forEach((item, index) => {
                        const obj = {
                            label: item.quotaName,
                            width: '180',
                            list: [ {
                                prop: `performanceResult${index}`,
                                label: '结果(%)',
                                width: '90'
                            },
                            {
                                prop: `fineAmount${index}`,
                                label: '考核金额',
                                width: '90'
                            }]
                        };
                        this.columnsList.push(obj);
                    });
                    this.columnsList = this.columnsList.concat(this.columnsLast);
                }
                this.tableData = res.data.list;
                this.tableData = this.conversionData(this.tableData);
                this.tableData.forEach((item2, index2) => {
                    if (this.tableData[index2].quotaTypeDtoList) {
                        this.tableData[index2].quotaTypeDtoList.forEach((item3, index3) => {
                            item2[`performanceResult${index3}`] = item3.performanceResult;
                            item2[`fineAmount${index3}`] = item3.fineAmount;
                        });
                    }
                });
                this.totalCount = res.data.totalCount;
            }
            const chartRes = await getChart({ ...this.searchInfo });
            if (chartRes && chartRes.code === '0') { this.$emit('chartData', chartRes); }
        },
        conversionData(list) {
            list.map(item => {
                item.businessCategory = this.dictData.SRM_PERFOR_BUSINESS_CATEGORY[item.businessCategory];
            });
            return list;
        },
        exportList() {
            let str = '';
            const { companyName, siteName, businessCategory, assessmentYear } = this.searchInfo;
            const obj = { companyName, siteName, businessCategory, assessmentYear };
            for (const key in obj) {
                if (obj[key]) {
                    str += `${key}=${obj[key]}&`;
                }
            }
            str += `supplierCode=${this.searchInfo.supplierCode}&`;
            if (str.length !== 0) { str = str.substring(0, str.length - 1); }
            window.location = config.apiUrl + this.exportUrl + `?${str}`;
        },
        handleCurrentChange(val) {
            this.searchInfo.pageNo = val;
            this.loadData();
        },
        handleSizeChange(val) {
            this.searchInfo.pageSize = val;
            this.loadData();
        },
        searchChange(data) {
            if (data.assessmentYear) { data.assessmentYear = formatTime.formatDateTime(data.assessmentYear).slice(0, 4); }
            this.searchInfo.pageNo = 1;
            this.searchInfo = { ...this.searchInfo, ...data };
            this.loadData();
        }
    }
};
</script>
<style lang="less">
.monthly-assessment-table {
    .btn-box {
        display: flex;
        justify-content: flex-end;
    }
    .monthly-table {
        margin-top: 10px;
    }
    .el-table__header tr,
    .el-table__header th {
        padding: 0;
        height: 20px;
    }
}
.popover-wrapper-form-monthly-assessment {
    .item div:first-child {
        width: 100%;
    }
}
.popover-btn-monthly-assessment {
    float: right;
    margin-left: 10px;
}
</style>